/* attachEvent */
// **********************************************************
// Card Like
// **********************************************************

attachEvent('.card__wishlist-button', 'click', (ev) => {
		ev.preventDefault();
		const axiosData = new FormData();
		axiosData.append('action', 'toggleItemOnLikedList');
		axiosData.append('productid', ev.target.closest('button').dataset.productid);
		axios
				.post(localData.siteURL, axiosData, {
						headers: {
								'Content-Type': 'multipart/form-data',
						},
				})
				.then((response) => {
						if (response.status === 200) {
								ev.target.closest('.card__wishlist-button').classList.toggle('is-liked', response.data.data.liked);
								updateWishListQuantityBadge()
						}
				})
});
